export enum ReplyToEmailModeEnum {
  none = 'none',
  advisor = 'advisor',
  other = 'other',
}
